import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import s from './Gallery.module.css'

export default function Gallery({ images }) {
    const swiperRef = useRef(null);

    return (
        <div className={s.gallery}>
            {/* Custom navigation arrows */}
            <button
                type="button"
                aria-label="Previous slide"
                className={`${s.nav} ${s.navPrev}`}
                onClick={() => swiperRef.current?.slidePrev()}
            >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" style={{ marginLeft: '-2px' }} >
                    <path
                        d="M15 6l-6 6 6 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            <button
                type="button"
                aria-label="Next slide"
                className={`${s.nav} ${s.navNext}`}
                onClick={() => swiperRef.current?.slideNext()}
            >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" style={{ marginRight: '-2px' }} >
                    <path
                        d="M9 6l6 6-6 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>

            <Swiper
                modules={[Navigation, Autoplay]}
                // removed Swiper's built-in navigation; using custom buttons above
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop
                breakpoints={{
                    0: { slidesPerView: 1 },
                    480: { slidesPerView: 1 },
                    769: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
                className={s.swiper}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
            >
                {images?.map((src, i) => (
                    <SwiperSlide key={i}>
                        <div className={s.slide}>
                            <img src={src} alt={`Bowling ${i + 1}`} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}
